module.exports = __webpack_public_path__ + "img/guayaquil.2dcff111.jpg";